<div [formGroup]="parent">
  <div class="form-field" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}">
    <div class="col-md-12 clear-all tooltip-flex-container">
      <label for="{{controllerData['name']}}" class="form-label"
      [id]="'lbl-'+controllerData['label']">{{controllerData['label']}}</label>
      @if (controllerData['name'] === 'addressline1' && (pageName === 'registration' || pageName === 'register')) {
        <div class="info-icon d-view">
          <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
            class="col-sm-1 padding-for-toolTip" (displayMobileTooltipEmitter)="displayTooltipMessage('firstname')">
          </app-tool-tip-notification>
        </div>
      }
      @if (controllerData['name'] === 'addressline1' && (pageName === 'registration' || pageName === 'register')) {
        <div class="col-md-12 clear-all info-icon mt-view">
          <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
            (displayMobileTooltipEmitter)="displayTooltipMessage('firstname')">
          </app-tool-tip-notification>
        </div>
      }
    </div>

    <div class="form-field-text">
      <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" type="text"
        [id]="controllerData['name']" [(ngModel)]="textValue" aria-invalid="false"
        [placeholder]="controllerData['placeHolder']" [maxlength]="controllerData['maxlength']" class="form-control"
        [value]="controllerData['value']" [required]="controllerData['required']"
        (blur)="inputTextChangeHandler($event.target.value)" />

      </div>

      @if (displayTooltipAlert) {
        <app-modal [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
          (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
        [tooltipFlag]="true"></app-modal>
      }

      @if (parent.get(controlName).touched
        &&
        parent.get(controlName).errors) {
        <div [id]="controlName +'-error'" class="form-validation-error">
          <i class="icon icon-error" aria-hidden="true"></i>
          @if (parent.get(controlName).touched
            &&
            parent.get(controlName).hasError('required')) {
            <p [id]="controlName +'-error'">
            {{controllerData['errorMessage']}}</p>
          }
        </div>
      }
    </div>
  </div>